export default "__VITE_ASSET__B5acAl04__"